'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = reducer;
exports.filter = filter;
exports.loadContacts = loadContacts;
exports.deleteContact = deleteContact;
exports.addContact = addContact;
exports.addContacts = addContacts;
exports.loadGroups = loadGroups;
exports.deleteGroup = deleteGroup;
exports.addGroup = addGroup;
exports.loadGroupContacts = loadGroupContacts;
exports.removeContactFromGroup = removeContactFromGroup;
exports.addAllContactsToGroup = addAllContactsToGroup;
exports.removeAllContactsFromGroup = removeAllContactsFromGroup;
exports.saveGroupContacts = saveGroupContacts;
exports.moveContactToGroup = moveContactToGroup;
exports.deleteGroupContact = deleteGroupContact;
exports.deleteGroupContacts = deleteGroupContacts;
exports.setContactsListLimit = setContactsListLimit;
exports.loadSuggestionUsersList = loadSuggestionUsersList;
exports.setGroupContactsPage = setGroupContactsPage;
exports.filterGroupContacts = filterGroupContacts;
exports.updateCheckedGroupContacts = updateCheckedGroupContacts;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _utils = require('helpers/utils');

var _qim = require('qim');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE = 'contacts/UPDATE'; /* Contacts and groups redux reducer and action creators */

var FILTER = 'contacts/FILTER';
var ADD_CONTACTS = 'contacts/ADD_CONTACTS';
var UPDATE_GROUP = 'contacts/UPDATE_GROUP';
var SET_CONTACTS_LIST_LIMIT = 'contacts/SET_CONTACTS_LIST_LIMIT';
var SET_GROUP_CONTACTS_PAGE = 'contacts/SET_GROUP_CONTACTS_PAGE';
var FILTER_GROUP_CONTACTS = 'contacts/FILTER_GROUP_CONTACTS';
var UPDATE_CHECKED_GROUP_CONTACTS = 'contacts/UPDATE_CHECKED_GROUP_CONTACTS';

var loadReducer = (0, _loadReducer2.default)('contacts', {
  contactsList: { action: 'load', init: { contacts: [] }, keepOnLoad: true },
  deleteContact: {},
  groupsList: { action: 'load', init: [] },
  deleteGroup: {},
  addContact: {},
  addGroup: {},
  groupContactsList: { action: 'load', init: [] },
  contactsWithoutGroup: { action: 'load', init: [] },
  saveGroupContacts: { init: {} },
  suggestionList: { action: 'load', init: { contacts: [] } }
});

var initialState = (0, _extends3.default)({}, loadReducer.initialState, {
  contactsManageGroupData: [],
  kw: '',
  groupContactsKw: '',
  contactsListLimit: 100,
  contactsListPage: 1,
  contactsListPaginateBy: [10, 30, 60, 100],
  groupContactsPage: 1,
  checkedGroupContacts: {}
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case loadReducer.constants.SAVE_GROUP_CONTACTS_SUCCESS:
      {
        if (action.groupId === state.groupContactsListActionData.groupId) {
          return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
            groupContactsListData: (0, _get3.default)(action, 'result.data', [])
          });
        }
        return loadReducer.reducer(state, action);
      }
    case loadReducer.constants.LOAD_CONTACTS_LIST:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        kw: action.kw,
        contactsListPage: action.page
      });
    case loadReducer.constants.DELETE_CONTACT_SUCCESS:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        contactsListData: (0, _extends3.default)({}, state.contactsListData, {
          contacts: (0, _reject3.default)(state.contactsListData.contacts, { id: action.contactId })
        })
      });
    case loadReducer.constants.DELETE_GROUP_SUCCESS:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        groupsListData: (0, _reject3.default)(state.groupsListData, { id: action.groupId })
      });
    case loadReducer.constants.ADD_CONTACT_SUCCESS:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        contactsListData: (0, _extends3.default)({}, state.contactsListData, {
          contacts: [].concat((0, _toConsumableArray3.default)(state.contactsListData.contacts), [(0, _get3.default)(action, 'result.data')])
        }),
        groupContactsListData: action.groupId ? [].concat((0, _toConsumableArray3.default)(state.groupContactsListData), [(0, _get3.default)(action, 'result.data')]) : state.groupContactsListData
      });
    case loadReducer.constants.ADD_GROUP_SUCCESS:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        groupsListData: [].concat((0, _toConsumableArray3.default)(state.groupsListData), [(0, _get3.default)(action, 'result.data.group[0]')])
      });
    case ADD_CONTACTS:
      {
        return (0, _qim.update)(['contactsListData', 'contacts', _qim.$end, (0, _qim.$set)(action.contacts.filter(function (contact) {
          return !contact.result;
        }))], state);
      }
    case UPDATE_GROUP:
      return (0, _extends3.default)({}, state, {
        groupContactsListData: action.groupContactsListData
      });
    case UPDATE:
      return (0, _extends3.default)({}, state, {
        contactsManageGroupData: action.contactsManageGroup,
        contactsWithoutGroupData: action.contactsWithoutGroup,
        kw: action.kw
      });
    case FILTER:
      return (0, _extends3.default)({}, state, {
        kw: action.kw
      });
    case SET_CONTACTS_LIST_LIMIT:
      return (0, _extends3.default)({}, state, {
        contactsListLimit: action.limit
      });
    case SET_GROUP_CONTACTS_PAGE:
      return (0, _extends3.default)({}, state, {
        groupContactsPage: action.page
      });
    case FILTER_GROUP_CONTACTS:
      return (0, _extends3.default)({}, state, {
        groupContactsKw: action.kw,
        groupContactsPage: 1
      });
    case UPDATE_CHECKED_GROUP_CONTACTS:
      return (0, _extends3.default)({}, state, {
        checkedGroupContacts: action.checkedGroupContacts
      });
    default:
      return loadReducer.reducer(state, action);
  }
}

function filter() {
  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: FILTER,
    kw: kw
  };
}

function loadContacts() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      page = _ref.page,
      limit = _ref.limit,
      kw = _ref.kw;

  return {
    types: loadReducer.constantsByKey.contactsList,
    promise: function promise(client) {
      return client.post('contacts_wa/getContactsList', { data: { page: page, items: limit, kw: kw } });
    },
    page: page,
    limit: limit,
    kw: kw
  };
}

function deleteContact(contactId) {
  return {
    types: loadReducer.constantsByKey.deleteContact,
    promise: function promise(client) {
      return client.post('contacts_wa/deleteContact', { data: { contactId: contactId } });
    },
    contactId: contactId
  };
}

function addContact(data) {
  return (0, _extends3.default)({
    types: loadReducer.constantsByKey.addContact,
    promise: function promise(client) {
      return client.post('contacts_wa/addContact', { data: data });
    }
  }, data);
}

function addContacts(groupId, contacts) {
  return {
    type: ADD_CONTACTS,
    groupId: groupId,
    contacts: contacts
  };
}

function loadGroups() {
  return {
    types: loadReducer.constantsByKey.groupsList,
    promise: function promise(client) {
      return client.post('contacts_wa/listGroups');
    }
  };
}

function deleteGroup(groupId) {
  return {
    types: loadReducer.constantsByKey.deleteGroup,
    promise: function promise(client) {
      return client.post('contacts_wa/deleteGroup', { data: { groupId: groupId } });
    },
    groupId: groupId
  };
}

function addGroup(groupName) {
  return {
    types: loadReducer.constantsByKey.addGroup,
    promise: function promise(client) {
      return client.post('contacts_wa/addGroup', { data: { groupName: groupName } });
    },
    groupName: groupName
  };
}

function loadGroupContacts(groupId) {
  return {
    types: loadReducer.constantsByKey.groupContactsList,
    promise: function promise(client) {
      return client.post('contacts_wa/getContactsFromGroup', { data: { groupId: groupId } });
    },
    groupId: groupId
  };
}

function removeContactFromGroup(contact) {
  return function (dispatch, getState) {
    var state = getState();
    var groupContactsListData = (0, _reject3.default)(state.contacts.groupContactsListData, { id: contact.id });

    dispatch({
      type: UPDATE_GROUP,
      groupContactsListData: groupContactsListData
    });
  };
}

function addAllContactsToGroup() {
  return function (dispatch, getState) {
    var state = getState();
    var _state$contacts = state.contacts,
        contactsListData = _state$contacts.contactsListData,
        groupContactsListData = _state$contacts.groupContactsListData;

    var newGroupData = (0, _utils.mergeObjectArraysByKey)('id', groupContactsListData, contactsListData.contacts);

    dispatch({
      type: UPDATE_GROUP,
      groupContactsListData: newGroupData
    });
  };
}

function removeAllContactsFromGroup() {
  return {
    type: UPDATE_GROUP,
    groupContactsListData: []
  };
}

function saveGroupContacts(_ref2) {
  var groupId = _ref2.groupId,
      contacts = _ref2.contacts;

  return {
    types: loadReducer.constantsByKey.saveGroupContacts,
    promise: function promise(client) {
      return client.post('contacts_wa/resetGroupContacts', { data: { contacts: '[' + contacts.toString() + ']', groupId: groupId } });
    },
    contacts: contacts,
    groupId: groupId,
    abortable: true
  };
}

function moveContactToGroup(_ref3) {
  var contact = _ref3.contact,
      groupId = _ref3.groupId;

  return function (dispatch, getState) {
    var state = getState().contacts;
    var groupContactsIds = (0, _map3.default)(state.groupContactsListData, 'id');
    var groupContactsListData = [].concat((0, _toConsumableArray3.default)(state.groupContactsListData), [contact]);

    var result = dispatch(saveGroupContacts({ groupId: groupId, contacts: [].concat((0, _toConsumableArray3.default)(groupContactsIds), [contact.id]) }));

    dispatch({
      type: UPDATE_GROUP,
      groupContactsListData: groupContactsListData
    });
    return result;
  };
}

function deleteGroupContact(_ref4) {
  var contact = _ref4.contact,
      groupId = _ref4.groupId;

  return function (dispatch, getState) {
    var state = getState().contacts;
    var groupContacts = (0, _qim.update)([[_qim.$each, function (groupContact) {
      return groupContact.id === contact.id;
    }, _qim.$none]], state.groupContactsListData);

    var result = dispatch(saveGroupContacts({ groupId: groupId, contacts: (0, _map3.default)(groupContacts, 'id') }));

    dispatch({
      type: UPDATE_GROUP,
      groupContactsListData: groupContacts
    });
    return result;
  };
}
/*


function updateGroupContactsPageIfNecessary() {
  return (dispatch, getState) => {
    const state = getState().contacts;
    const page = state.groupContactsPage;
  };
}
*/

function deleteGroupContacts(_ref5) {
  var contacts = _ref5.contacts,
      groupId = _ref5.groupId;

  return function (dispatch, getState) {
    var state = getState().contacts;
    var groupContacts = (0, _qim.update)([[_qim.$each, function (groupContact) {
      return contacts.includes(groupContact.id);
    }, _qim.$none]], state.groupContactsListData);

    var result = dispatch(saveGroupContacts({ groupId: groupId, contacts: (0, _map3.default)(groupContacts, 'id') }));

    dispatch({
      type: UPDATE_GROUP,
      groupContactsListData: groupContacts
    });
    return result;
  };
}

function setContactsListLimit(limit) {
  return function (dispatch, getState) {
    var state = getState().contacts;
    dispatch(loadContacts({ page: 1, limit: limit, kw: state.kw }));

    dispatch({
      type: SET_CONTACTS_LIST_LIMIT,
      limit: limit
    });
  };
}

function loadSuggestionUsersList(kw) {
  var data = { kw: kw };
  return function (dispatch, getState) {
    var state = getState().project;
    if (!state.suggestionListLoading && !state.suggestionListLoaded /* && state.suggestionListActionData.kw !== kw*/) {
        return dispatch({
          types: loadReducer.constantsByKey.suggestionList,
          promise: function promise(client) {
            return client.post('contacts_wa/getContactsList', { data: data });
          },
          kw: kw
        });
      }
  };
}

function setGroupContactsPage(_ref6) {
  var page = _ref6.page;

  return {
    type: SET_GROUP_CONTACTS_PAGE,
    page: page
  };
}

function filterGroupContacts(kw) {
  return {
    type: FILTER_GROUP_CONTACTS,
    kw: kw
  };
}

function updateCheckedGroupContacts(checkedGroupContacts) {
  return {
    type: UPDATE_CHECKED_GROUP_CONTACTS,
    checkedGroupContacts: checkedGroupContacts
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/contacts.js
// module id = 61
// module chunks = 1